<template>
  <footer>
    <div class="container">
      <router-link to="/">
        <img src="../assets/logo-gray.png" width="373" style="filter: grayscale(100%); max-width: 100%">
      </router-link>
      <div class="footer-contacts">
        <div>
          <font-awesome-icon
            icon="fa-solid fa-location-dot"
            style="font-size: 16px; margin-left: auto"
          />
          <span style="margin-left: 10px">г. Мелитополь ул. Интеркультурная 77/4</span>
        </div>
        <div class="vertical-line" />
        <a href="https://t.me/tavriyapost">
          <img src="../assets/telega.svg" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter',
}
</script>

<style scoped>
footer {
  background-color: var(--bg-1);
}
.container {
  width: 97%;
  max-width: 1240px;
  padding-top: 25px;
  padding-bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  row-gap: 10px;
  margin: auto;
  color: white;
}
.container > div:first-child {
  font-size: 16px;
  display: flex;
  align-items: center;
}
.container > div:first-child span {
  margin-top: 20px;
}
.footer-contacts {
  display: flex;
  align-items: center;
  justify-content: center;
  row-gap: 10px;
  font-size: 14px;
}
.vertical-line {
  width: 0;
  margin: 0 15px;
}
.vertical-line:before {
  content: "";
  background: white;
  width: 1px;
  height: 32px;
  float: left;
  margin-right: 10px;
}

@media screen and (max-width: 768px) {
  .container {
    flex-direction: column;
    justify-content: center;
  }
  .footer-contacts {
    flex-direction: column;
  }
  .vertical-line, .vertical-line:before {
    display: none;
  }
}
</style>
